<template>
    <v-dialog v-model="showDialog"
              class="select-group-dialog"
              min-width="300"
              width="600"
              transition="dialog-bottom-transition">
        <v-card class="text-primary ma-0">
            <v-card-title>
                <span>{{title}}</span>
            </v-card-title>

            <v-card-text class="pa-4 py-0">
                <v-btn v-for="group in filteredGroups" :key="group.guid"
                       @click="selectGroup(group)"
                       class="w-100 mb-2"
                       color="primary"
                       variant="outlined">
                    "{{group.name}}" [{{getMiniGuid(group.guid)}}] {{getFilterInfoString(group)}}
                </v-btn>
            </v-card-text>

            <v-card-actions class="mb-2 mr-2">
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="$emit('hide')">Отменить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        components: {

        },

        props: {
            title: String,
            groups: Array,
            filterGroupsIds: Array,
            filterUsersIds: Array
        },

        emits: ["select:group", "hide"],

        data() {
            return {
                showDialog: true
            };
        },

        computed: {
            filteredGroups() {
                if (!this.filterGroupsIds || this.filterGroupsIds.length === 0) {
                    return this.groups;
                }

                return this.groups
                    .filter(g => !this.filterGroupsIds.some(id => id === g.id));
            }
        },

        watch: {
            showDialog(newValue) {
                if (newValue === false) {
                    this.$emit("hide");
                }
            }
        },

        methods: {
            getMiniGuid(guid) {
                return guid.substring(0, 8);
            },

            selectGroup(group) {
                if (!this.haveMembers(group)) {
                    return;
                }

                this.$emit("select:group", group);
            },

            haveMembers(group) {
                if (!group.members
                    || !this.filterUsersIds
                    || this.filterUsersIds.length === 0) {
                    return group.membersCount > 0;
                }

                return group.members
                    .filter(u => !this.filterUsersIds.some(id => id === u.id))
                    .length > 0;
            },

            getFilterInfoString(group) {
                if (!group.members
                    || !this.filterUsersIds
                    || this.filterUsersIds.length === 0) {
                    return `(${group.membersCount})`;
                }

                const filteredMembersCount = group.members
                    .filter(u => !this.filterUsersIds.some(id => id === u.id))
                    .length;

                return `(${filteredMembersCount} / ${group.membersCount})`;
            }
        }
    };
</script>

<style lang="scss">
    .select-group-dialog {
    }
</style>